// src/redux/otherinvoiceSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_other_invoice,
  add_other_invoice,
  update_other_invoice,
  delete_other_invoice,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';
const getTodayDate = () => {
  const today = new Date();
  const offset = today.getTimezoneOffset();
  today.setMinutes(today.getMinutes() - offset);
  return today.toISOString().split("T")[0];
};
const initialState = {
  otherinvoice: [],
  otherinvoicelist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    date :getTodayDate() || "",
    user:"",
    general_description :"",
    gst_amount :"",
    // subtotal :"",
    // total_discount :"",
    // total_amount :"",
    pay_status :"",
    // supporting_doc :"",
    bank_account :"",

  },
};



// Async Thunks for API Calls
export const fetchotherinvoice = createAsyncThunk(
  "otherinvoice/fetchotherinvoice",
  async ({ page, page_size,user_id,search,school_id, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_other_invoice(page, page_size, user_id,search,school_id, token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createotherinvoice = createAsyncThunk(
  "otherinvoice/createotherinvoice",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_other_invoice(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateotherinvoice = createAsyncThunk(
  "otherinvoice/updateotherinvoice",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_other_invoice(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteotherinvoice = createAsyncThunk(
  "otherinvoice/deleteotherinvoice",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_other_invoice({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// otherinvoice Slice
const otherinvoiceSlice = createSlice({
  name: 'otherinvoices',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
  EditFormData(reduxState, action) {
      reduxState.formData = { ...action.payload };
    },
    resetFormData(state) {
      state.formData = {
       date :getTodayDate() || "",
    user:"",
    general_description :"",
    gst_amount :"",
    // subtotal :"",
    // total_discount :"",
    // total_amount :"",
    pay_status :"",
    // supporting_doc :"",
    bank_account :"",
      };
    },
    setotherinvoice(state, action) {
      state.otherinvoice = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

       // Fetch otherinvoice
       .addCase(fetchotherinvoice.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchotherinvoice.fulfilled, (state, action) => {
        state.loading = false;
        state.otherinvoice = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchotherinvoice.rejected, (state, action) => {
        state.loading = false;
        state.otherinvoice = [];
        state.error = action.payload;
      })

      // Add otherinvoice
      .addCase(createotherinvoice.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createotherinvoice.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createotherinvoice.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update otherinvoice
      .addCase(updateotherinvoice.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateotherinvoice.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateotherinvoice.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete otherinvoice
      .addCase(deleteotherinvoice.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteotherinvoice.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteotherinvoice.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setotherinvoice,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = otherinvoiceSlice.actions;
export default otherinvoiceSlice.reducer;
